import { createDeferredI18n } from "#/shared/composables/useI18n";
import fallbackMessages from "#/shared/i18n/frontend.index_filters.json";

const { i18n, ready: whenI18nReady } = createDeferredI18n({ key: "index_filters", fallbackMessages });

export { whenI18nReady };
export const t = i18n.global.t;
